/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

/* Helpers, constants, custom methods, internal libraries */
/* Components */
import UCButton from "../../buttons";

/* Styles */
import styles from "./styles.js"
import {colors} from "../../../constants/colors";


const Footer = props => {
  const { setShowModal, handleSaveModal } = props;

  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <ContainerFluid className="gx-0">
      <Row>
        <Col>
          <UCButton
            onClick={() => setShowModal(false)}
            type="default"
            className={classes.cancelBtn}
            text={<FormattedMessage id="companiesSwitcherModal.cancel"/>}
          />
        </Col>
        <Col>
          <UCButton
            spinner={{
              name: "companiesSwitcherSpinner",
              size: 20,
            }}
            className={classes.saveBtn}
            onClick={handleSaveModal}
            type="primary"
            text={<FormattedMessage id="companiesSwitcherModal.change"/>}
            dataTestId="companiesswitchermodalsubmit"
          />
        </Col>
      </Row>
    </ContainerFluid>
  )
}

export default Footer;
